/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const ADMIN_CAN_ABILITY = [
  //Route Access
  ["read", "MyProfile"],
  ["read", "OrgProfile"],
  ["read", "DashboardOverview"],
  ["read", "DashboardIssuerAnalysis"],
  ["read", "DashboardVerifierAnalysis"],
  ["read", "UsersList"],
  ["read", "HoldersGroups"],
  ["read", "HoldersGroups.Holders"],
  ["read", "Holders"],
  ["read", "Credential"],
  ["read", "HoldersBatchImport"],
  ["read", "IssuedCredentialList"],
  ["read", "CredentialList"],
  ["read", "IssueNewCredential"],
  ["read", "IssuedNetworkGraph"],
  ["read", "CreateCredentialTemplate"],
  ["read", "Placeholder"],
  ["read", "Templates"],
  ["read", "IssueCredential"],
  ["read", "PortfolioTemplate"], 
  ["read", "CreatePortfolioTemplate"], 
  ["read", "PortfolioTemplates"],
  ["read", "PortfolioUnderReview"],
  ["read", "CreatedEPortfolio"],
  ["read", "ListedEPortfolio"],
  ["read", "ReviewedEPortfolio"],
  ["read", "PortfoliosForReview"],
  ["read", "ReviewEPortfolio"],
  ["read", "VerifyPortfolioCredential"]
];

export const ADMIN_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
];
